import { formatDate } from '../../../../utils/date';

export const formatEvaluationMessage = ({
    user,
    member,
    activityName,
    currentTopics,
    levels,
    topicMetaById,
    maxLevelValue,
    allTopicIds,
    prevEvals,
    lastEval,
    calculatePct
}) => {
    // 5. Construir cabeçalho de progresso (Timeline Visual)
    let progressHeader = `🏆 *RESULTADO DA AVALIAÇÃO*\n`;
    progressHeader += `━━━━━━━━━━━━━━━━━━━━━━\n`;
    if (user?.tenantName) progressHeader += `🏢 *Academia:* ${user.tenantName}\n`;
    progressHeader += `👤 *Aluno(a):* ${member.name}\n`;
    if (activityName) progressHeader += `🥋 *Modalidade:* ${activityName}\n`;
    progressHeader += `📅 *Data:* ${formatDate(new Date(), 'DD/MM/YYYY')}\n`;
    progressHeader += `━━━━━━━━━━━━━━━━━━━━━━\n\n`;

    progressHeader += `📈 *HISTÓRICO DE EVOLUÇÃO:*\n`;

    if (prevEvals && prevEvals.length > 0) {
        // Montar histórico (mais antigas primeiro na leitura de cima pra baixo)
        const historyLines = [...prevEvals].reverse().map((ev, idx) => {
            const allEvTopics = ev.objectives ? ev.objectives.flatMap(o => o.topics || []) : [];
            const pct = calculatePct(allEvTopics);
            const statusIcon = idx === 0 ? '📉' : '📊';
            return `${statusIcon} ${formatDate(ev.date, 'DD/MM/YYYY')}: ${pct}%`;
        });
        progressHeader += `${historyLines.join('\n')}\n`;
    }

    const currentPercent = calculatePct(currentTopics);
    progressHeader += `🚀 *HOJE:* ${currentPercent}% de avanço\n`;
    progressHeader += `━━━━━━━━━━━━━━━━━━━━━━\n\n`;

    // 6. Agrupar tópicos por Objetivo e detectar MELHORA (👍)
    const groupedByObjective = currentTopics.reduce((acc, curr) => {
        const objectiveTitle = topicMetaById[curr.id]?.objectiveName || "Geral";
        if (!acc[objectiveTitle]) acc[objectiveTitle] = [];

        let improved = false;
        let prevLevelName = "";

        if (lastEval && lastEval.objectives) {
            const allPrevTopics = lastEval.objectives.flatMap(o => o.topics || []);
            const prevCrit = allPrevTopics.find(c => String(c.idTopic || c.id) === String(curr.id));
            if (prevCrit) {
                const prevLevel = levels.find(l => String(l.id) === String(prevCrit.idLevel));
                if (prevLevel) {
                    const prevOrder = Number(prevLevel.order ?? prevLevel.value ?? 0);
                    if (curr.order > prevOrder) {
                        improved = true;
                        prevLevelName = prevLevel.name || prevLevel.title;
                    }
                }
            }
        }

        acc[objectiveTitle].push({ ...curr, improved, prevLevelName });
        return acc;
    }, {});

    const resultsDetailed = Object.entries(groupedByObjective).map(([objective, items]) => {
        const itemsText = items.map(c => {
            const fundTag = c.isFundamental ? ' ⚡ _Fundamental_' : '';
            let topicLine = `🔹 *${c.name}*${fundTag}`;

            if (c.improved && c.prevLevelName) {
                // Estilo de Evolução: Nível Anterior ➔ Nível Atual
                topicLine += `\n   ${c.prevLevelName} ➔ *${c.levelName}* 👍`;
            } else {
                // Estilo padrão: Nível Atual
                topicLine += `\n   ⭐ *${c.levelName}*`;
            }
            return topicLine;
        }).join('\n\n');

        return `📚 *${objective.toUpperCase()}*\n${itemsText}`;
    }).join('\n\n──────────────────\n\n');

    return `${progressHeader}${resultsDetailed}`;
};
